module.exports = __webpack_public_path__ + "static/img/blackjack_en.d9c8be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/blackjack_en.png
// module id = aaMT
// module chunks = 1